<script lang="ts">
import "@cisco-u/modal/cu-modal.js";
import "@cisco-u/button/cu-button.js";

import { defineComponent } from "vue";

export default defineComponent({
  emits: ["hide-global-success"],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    closeModal() {
      this.$emit("hide-global-success");
    },
  },
});
</script>

<template>
  <cu-modal
    v-if="showModal"
    class="site-wide-message-modal"
    type="small"
    :showLogo="true"
    logoWidth="5rem"
    width="39rem"
    :open="showModal"
    data-cy="success-modal-mask"
    @modalResponse="closeModal"
  >
    <div slot="header" class="px-4 text-22 font-light text-white-lightest">
      Success
    </div>
    <div slot="body">
      <div
        class="px-[1.875rem] py-8 text-center font-cisco text-18 font-light text-black-darkest"
      >
        The survey was successfully reset
      </div>
      <div class="flex justify-center pb-8">
        <cu-button
          template="primary"
          size="m"
          data-cy="close-success-alert-ok"
          @click="closeModal()"
          @keyup.enter="closeModal()"
          @keyup.space="closeModal()"
        >
          Okay
        </cu-button>
      </div>
    </div>
  </cu-modal>
</template>
